import React from 'react'
import "./clients.css"


export default function Clients() {
  return (
    <div className='container py-5'>
        <div className='d-flex justify-content-between align-items-center my-5'>
        <p className='h3 fw600'>My Clients</p>
        <p style={{width:"50%", textAlign:"right"}} className='grey-text'>I've had the pleasure of working with some reputable brands.</p>
        </div>
    <div className='row'>
        <div className="col-sm-12 col-md-4 col-lg-3 mb-5 fs-ctn d-flex flex-direction-column justify-content-center">
            <img id='fs-logo' src="./img/logos/Futostore greyfill.png" alt="Futostore Brand" />
            <img id='fs-hover' src="./img/logos/Futostore orangefill.png" alt="Futostore Brand" />
        </div>
        <div className="col-sm-12 col-md-4 col-lg-3 mb-5 odc-ctn d-flex flex-direction-column justify-content-center">
            <img id='odc-logo' src="./img/logos/Onlinedrugcrib greyfill.png" alt="Onlinedrugcrib Brand" />
            <img id='odc-hover' src="./img/logos/Onlinedrugcrib orangefill.png" alt="Onlinedrugcrib Brand" />
        </div>
        <div className="col-sm-12 col-md-4 col-lg-3 mb-5 oe-ctn d-flex flex-direction-column justify-content-center">
            <img id='oe-logo' src="./img/logos/Oyemexchange greyfill.png" alt="Oyemexchange Brand" />
            <img id='oe-hover' src="./img/logos/Oyemexchange orangefill.png" alt="Oyemexchange Brand" />
        </div>
        <div className="col-sm-12 col-md-4 col-lg-3 mb-5 qf-ctn d-flex flex-direction-column justify-content-center">
            <img id='qf-logo' src="./img/logos/Qweekfood greyfill.png" alt="Qweekfood Brand" />
            <img id='qf-hover' src="./img/logos/Qweekfood orangefill.png" alt="Qweekfood Brand" />
        </div>
        <div className="col-sm-6 col-md-4 col-lg-3 mb-5 rs-ctn d-flex flex-direction-column justify-content-center">
            <img id='rs-logo' src="./img/logos/Raverstudio greyfill.png" alt="Raverstudio Brand" />
            <img id='rs-hover' src="./img/logos/Raverstudio orangefill.png" alt="Raverstudio Brand" />
        </div>
        <div className="col-sm-6 col-md-4 col-lg-3 mb-5 rx-ctn d-flex flex-direction-column justify-content-center">
            <img id='rx-logo' src="./img/logos/Rexxedia greyfill.png" alt="Rexxedia Brand" />
            <img id='rx-hover' src="./img/logos/Rexxedia orangefill.png" alt="Rexxedia Brand" />
        </div>
        <div className="col-sm-6 col-md-4 col-lg-3 mb-5 ts-ctn d-flex flex-direction-column justify-content-center">
            <img id='ts-logo' src="./img/logos/Tronsmartline greyfill.png" alt="Tronsmartline Brand" />
            <img id='ts-hover' src="./img/logos/Tronsmartline orangefill.png" alt="Tronsmartline Brand" />
        </div>
        <div className="col-sm-6 col-md-4 col-lg-3 mb-5 ws-ctn d-flex flex-direction-column justify-content-center">
            <img id='ws-logo' src="./img/logos/Wheatstonegates greyfill.png" alt="Wheatstonegates Brand" />
            <img id='ws-hover' src="./img/logos/Wheatstonegates orangefill.png" alt="Wheatstonegates Brand" />
        </div>
    </div>
    <div className='mt-5'>
    <p className='h2'><a target='_blank' rel="noreferrer" href='https://forms.gle/93JT3g19gJpCufYL6'>Let's talk <i class="bi bi-arrow-right-circle"></i></a></p>
    </div>
        </div>
  )
}
